import { render, staticRenderFns } from "./IconArrowNarrowDownSolid.vue?vue&type=template&id=ec60fc1a"
import script from "./IconArrowNarrowDownSolid.vue?vue&type=script&lang=js"
export * from "./IconArrowNarrowDownSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports